import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Alert, Button, Spin } from 'antd';
import Translate from 'react-translate-component';
import { withAsyncActions } from 'react-async-client';
import * as yup from 'yup';
import { Field } from 'react-final-form';

import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import { login, recoverySuccess } from 'constants/routes';
import ErrorHTML from 'components/common/form/ErrorHTML';
import GuestInput from 'components/common/form/GuestInput';
import GuestFooter from 'components/layout/guest/GuestFooter';
import { recoveryPassword } from 'actions/userActions';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import withFormWrapper from 'components/hocs/withFormWrapper';
import CustomIcon from 'components/common/CustomIcon';

const validationSchema = yup.object().shape({
    email: yup.string().email('emailError').required(),
});

const initialValues = {
    'url-with-token': `${window.location.origin}/#/reset/`
};

@withAutoFocusForm
@withAsyncActions({ formAction: recoveryPassword }, { resetOnUnmount: true })
@withFormWrapper({
    validationSchema,
    mapPropsToValues: () => initialValues
})
@withRouteOptions
export default class RecoveryView extends Component {
    static routeOptions = {
        title: 'guest.recoveryPage'
    };

    render() {
        const { formAction: { meta } } = this.props;

        if (meta.success) {
            return <Redirect to={recoverySuccess.path} />;
        }

        return (
            <Fragment>
                <Spin spinning={Boolean(meta.pending)}>
                    { meta.error && (
                        <ErrorHTML meta={meta} className='guest-layout-error' />
                    )}
                    <Field
                        name="email"
                        component={GuestInput}
                        type="text"
                        placeholder={"guest.email"}
                        prefix={<CustomIcon type="user-man" />}
                        notWrap
                    />
                    <Button htmlType="submit" type="primary" size="large" className="login-form-button">
                        <Translate content="guest.recovery" />
                    </Button>
                </Spin>
                <GuestFooter>
                    <Link to={login.path}>
                        <Translate content="guest.toLogin" />
                    </Link>
                </GuestFooter>
            </Fragment>
        );
    }
}

export class RecoverySuccessView extends Component {
    render() {
        return (
            <div className="guest-success">
                <Alert message={ <Translate content="guest.passwordResetSuccess" /> } type="success" />
                <GuestFooter>
                    <Link to={login.path}>
                        <Translate content="guest.toLogin" />
                    </Link>
                </GuestFooter>
            </div>
        );
    }
}
